import React, { useState } from 'react';
import { Save, Trash2, Upload } from 'lucide-react';
import { programsAdminAPI } from '../../services/api';

const ProgramFcmCredentials = ({ programId, hasCredentials, projectId, onUpdated }) => {
  const [jsonText, setJsonText] = useState('');
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const text = await file.text();
    setJsonText(text);
  };

  const save = async () => {
    setSaving(true);
    setFeedback(null);
    try {
      let parsed;
      try {
        parsed = JSON.parse(jsonText);
      } catch (_) {
        throw new Error('JSON inválido.');
      }
      await programsAdminAPI.updateFcmCredentials(programId, parsed);
      setFeedback({ type: 'success', message: 'Credenciais salvas.' });
      setJsonText('');
      if (onUpdated) onUpdated();
    } catch (err) {
      setFeedback({
        type: 'error',
        message: err.response?.data?.message || err.message || 'Falha ao salvar.',
      });
    } finally {
      setSaving(false);
    }
  };

  const remove = async () => {
    if (!window.confirm('Remover credenciais FCM? Notificações cairão no app default.')) return;
    setSaving(true);
    setFeedback(null);
    try {
      await programsAdminAPI.updateFcmCredentials(programId, null);
      setFeedback({ type: 'success', message: 'Credenciais removidas.' });
      if (onUpdated) onUpdated();
    } catch (err) {
      setFeedback({
        type: 'error',
        message: err.response?.data?.message || 'Falha ao remover.',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="form-section">
      <h2>Firebase Cloud Messaging</h2>

      {hasCredentials ? (
        <div className="alert" style={{ marginBottom: 12, background: 'rgba(32, 255, 128, 0.08)', borderColor: 'rgba(32, 255, 128, 0.3)' }}>
          ✓ Credenciais ativas
          {projectId && <span style={{ marginLeft: 8, opacity: 0.8 }}>(project: {projectId})</span>}
        </div>
      ) : (
        <div className="alert" style={{ marginBottom: 12, opacity: 0.7 }}>
          Sem credenciais — push notifications usarão o app default do Firebase.
        </div>
      )}

      <div style={{ marginBottom: 12 }}>
        <label
          className="btn btn-ghost btn-with-icon"
          style={{ cursor: 'pointer', display: 'inline-flex' }}
        >
          <Upload size={16} /> Selecionar service account JSON
          <input
            type="file"
            accept="application/json,.json"
            onChange={onFile}
            style={{ display: 'none' }}
          />
        </label>
        <small style={{ marginLeft: 12, opacity: 0.7 }}>
          Service account com permissão Firebase Cloud Messaging API.
        </small>
      </div>

      <label className="span-2" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <span>JSON do service account</span>
        <textarea
          rows={10}
          value={jsonText}
          onChange={(e) => setJsonText(e.target.value)}
          placeholder='{"type":"service_account","project_id":"...","private_key":"..."}'
          style={{ fontFamily: 'monospace', fontSize: 11 }}
        />
      </label>

      {feedback && (
        <div
          className={'alert ' + (feedback.type === 'error' ? 'alert-danger' : '')}
          style={{ marginTop: 12 }}
        >
          {feedback.message}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button
          type="button"
          className="btn btn-primary btn-with-icon"
          onClick={save}
          disabled={saving || !jsonText.trim()}
        >
          <Save size={16} /> {saving ? 'Salvando...' : 'Salvar credenciais'}
        </button>
        {hasCredentials && (
          <button
            type="button"
            className="btn btn-ghost btn-with-icon"
            onClick={remove}
            disabled={saving}
            style={{ color: '#f87171' }}
          >
            <Trash2 size={16} /> Remover
          </button>
        )}
      </div>
    </section>
  );
};

export default ProgramFcmCredentials;
